module.exports = __webpack_public_path__ + "static/media/colorfulcave.f51d8c2b.png";